import { SCORE_TIERS } from './gameConstants';

export const SCORE_VALUES = {
  RAFFLESIA_HINT: 50,
  KERIS: 100,
  HAZARD_DODGE_BONUS: 50,
  SAFE_ROUTE: 200,
  HELP_CITIZENS: 150,
  EMERGENCY_ESSENTIAL: 5,
  EMERGENCY_DOCUMENT: 3,
  EMERGENCY_UTILITY: 2,
  DISTRACTOR: -2,
  /** Bonus saat menyelesaikan misi ke Ibundo — menyelaraskan tier konsep 801+. */
  MISSION_COMPLETE: 5,
} as const;

export interface ScoreRule {
  id: string;
  label: string;
  points: number;
  zone: number;
}

export const SCORE_RULES: ScoreRule[] = [
  { id: 'zone1_hint', label: 'Petunjuk pertama diperoleh', points: SCORE_VALUES.RAFFLESIA_HINT, zone: 1 },
  { id: 'zone2_keris1', label: 'Keris 1 berhasil ditemukan', points: SCORE_VALUES.KERIS, zone: 2 },
  { id: 'zone2_dodge', label: 'Berhasil menghindar tanpa terkena reruntuhan', points: SCORE_VALUES.HAZARD_DODGE_BONUS, zone: 2 },
  { id: 'zone3_keris2', label: 'Keris 2 berhasil ditemukan', points: SCORE_VALUES.KERIS, zone: 3 },
  { id: 'zone3_essential', label: 'Barang essential Tas Darurat', points: SCORE_VALUES.EMERGENCY_ESSENTIAL, zone: 3 },
  { id: 'zone3_documents', label: 'Dokumen penting Tas Darurat', points: SCORE_VALUES.EMERGENCY_DOCUMENT, zone: 3 },
  { id: 'zone3_utility', label: 'Barang utility Tas Darurat', points: SCORE_VALUES.EMERGENCY_UTILITY, zone: 3 },
  { id: 'zone3_distractor', label: 'Barang distractor/luxury', points: SCORE_VALUES.DISTRACTOR, zone: 3 },
  { id: 'zone4_keris3', label: 'Keris 3 berhasil ditemukan', points: SCORE_VALUES.KERIS, zone: 4 },
  { id: 'zone4_safe_route', label: 'Memilih jalur bukit terbuka', points: SCORE_VALUES.SAFE_ROUTE, zone: 4 },
  { id: 'zone4_wrong_route', label: 'Jalur tepi sungai — tidak aman', points: 0, zone: 4 },
  { id: 'zone5_help', label: 'Membantu lansia dan ibu hamil', points: SCORE_VALUES.HELP_CITIZENS, zone: 5 },
  { id: 'zone5_panic', label: 'Panik — tidak membantu warga', points: 0, zone: 5 },
  { id: 'ending_mission', label: 'Menyelesaikan misi penyelamatan', points: SCORE_VALUES.MISSION_COMPLETE, zone: 5 },
];

export function getScoreRule(id: string): ScoreRule | undefined {
  return SCORE_RULES.find((r) => r.id === id);
}

export function getScoreTier(total: number): string {
  if (total >= SCORE_TIERS.HERO.min) return SCORE_TIERS.HERO.label;
  if (total >= SCORE_TIERS.VOLUNTEER.min) return SCORE_TIERS.VOLUNTEER.label;
  return SCORE_TIERS.CITIZEN.label;
}
